var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('iframe',{attrs:{"src":"https://app.cotador.firecodeit.net","height":"100%","width":"100%","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }